import request from '@/utils/request'

/**
 * 自定义分页筛选列表
 * @param {*} params
 * @returns
 */
export const getPaymentPage = (params) => {
  return request({
    method: 'GET',
    url: 'tools/v1/pay/tenant/page',
    params
  })
}

/**
 * 保存支付
 * @param {*} params
 * @returns
 */
export const savePayment = (data) => {
  return request({
    method: 'POST',
    url: 'tools/v1/pay/tenant/save',
    data
  })
}

/**
 * 删除支付
 * @param {*} id 支付id
 * @returns
 */
export const delPayment = (id) => {
  return request({
    method: 'DELETE',
    url: `tools/v1/pay/tenant/${id}`
  })
}

/**
 * 根据id获取支付信息
 * @param {*} id 支付id
 * @returns
 */
export const getPaymentById = (id) => {
  return request({
    method: 'GET',
    url: `tools/v1/pay/tenant/${id}`
  })
}
